<template>
  <div class="bg">
    <div class="overlay overlay-color">

    </div>
    <div class="login-title">
      DeepDigital Asset Management
    </div>
    <div class="content">
      <div class="middle-block">
        <div  class="top">
          <ul class="languages">
            <li class="language active-language">
              nl
            </li>
            <li class="language">
              en
            </li>
            <li class="language">
              de
            </li>
            <li class="language">
              fr
            </li>
          </ul>
        </div>
        <div class="bottom">
          <div class="logo">
            <!-- <v-icon :large="true" class="logo-icon">gps_fixed</v-icon> -->
            <v-icon :large="true" class="logo-icon">lock_open</v-icon>
          </div>
        <!-- TOKEN REQUEST FORM ------------------------------------->
          <div class="form" v-if="!tokenAvailable">
            <v-text-field
              v-model="email"
              browser-autocomplete="email"
              label="Gebruikersnaam / email"
            ></v-text-field>
            <div style="margin-bottom:14px; text-align:right;">
              <a href="/login">terug naar login</a>
            </div>                 
            <v-btn :depressed="true" :disabled=disabled block @click="requestPasswordReset">Wachtwoord reset aanvragen</v-btn>
          </div>

        <!-- PASSWORD RESET FORM ------------------------------------->
          <div class="form" v-if="tokenAvailable">
            <v-text-field
              type="password"
              v-model="newPassword"
              label="Nieuw wachtwoord"
            ></v-text-field>
            <div style="margin-bottom:14px; text-align:right;">
              <a href="/login">terug naar login</a>
            </div>            
            <v-btn :depressed="true" :disabled=resetDisabled block @click="changePassword">Wachtwoord wijzigen</v-btn>
          </div>
        </div>
      </div>
    </div>
    <notification></notification>
  </div>
</template>

<script>
import * as types from "../store/types"
import { mapGetters } from 'vuex'
import Notification from "../components/global/Notification"

export default {
    components: {
        Notification,
    },
    data() {
        return {
            token:null,
            disabled:false,
            resetDisabled:true,
            email: "",
            newPassword:null
        }
    },
    computed: {
        tokenAvailable() {
            return this.token ? true : false
        }
    },
    methods: {
        requestPasswordReset(){
            this.$store.dispatch(types.USER_REQUEST_RESET_PASSWORD, {email:this.email})
            .then((data) => {            
                if(data.message == 'USER_INACTIVE'){
                  this.$notify("Gebruiker is niet actief", {duration:15000, type: 'error'} )
                }
                else{
                  this.$notify("Er is een mail verstuurd naar het opgegeven email adres met instructies als het email adres bekend is als gebruiker.", {duration:15000, type: 'success'} )
                }
                
                this.disabled=true;
            })
            .catch( (data) => {
                if(data.message == 'USER_INACTIVE'){
                  this.$notify("Gebruiker is niet actief", {duration:15000, type: 'error'} )
                }
                else{
                  this.$notify("Geen geldig email adres gegeven", {duration:10000, type: 'error'} );
                }
            });
        },
        verifyToken(){
            this.$store.dispatch(types.USER_RESET_PASSWORD_TOKEN, {token:this.token})
            .then((data) => {            
                this.resetDisabled=false
            }).catch( (e) => {
                this.$notify("Aanvraag verlopen, Ga terug naar de login pagina en vraag opnieuw een nieuw wachtwoord aan.", {duration:10000, type: 'error'} )
            })            
        },
        changePassword(){
            this.resetDisabled=true
            this.$store.dispatch(types.USER_RESET_PASSWORD, {token:this.token, password:this.newPassword})
            .then((data) => {            
                this.$notify("Uw wachtwoord is gewijzigd. U kunt inloggen met uw nieuwe wachtwoord. U wordt terug nu terug gebracht naar de login pagina", {duration:10000, type: 'success'} )
                let vm = this
                setTimeout(()=>{
                  vm.$router.push('login')
                },5000)                 
            }).catch( (e) => {
                this.resetDisabled=false
                
                if(e.error == "NEW_PASSWORD_NOT_VALID"){
                    this.$notify("Ongeldig wachtwoord. Het Wachtwoord moet minimaal 6 karakters, 1 hoofdletter en/of 1 speciaal teken bevatten ", {duration:40000, type: 'error'} )
                }
            })              
        }
    },    
    mounted () {
        let token = this.$route.query.token
        if(token){
            this.token = token;
            this.verifyToken()
        }

    },
}
</script>

<style lang="scss" scoped>

</style>